<template>
    <div class="view-tasklists">
        <user-menu />
        <div class="wrapper">
            <masteradmin-sidebar-menu />
            <div class="content-wrapper">
                <div class="container-wrapper center">
                    <div>
                        <h3 class="d-inline heading">Subscription Level</h3>
                        <button class="d-inline btn btn-red float-right create-btn" @click="isModalVisible = true, verrors.clear()">
                        <i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Purchase Type
                        </button>
                    </div>
                    <div class="heading-seperator"></div>
                    <div class="margin-bottom-10"></div>
                    <div class="">
                        <b-navbar toggleable="lg" type="light" variant="light">
                            <b-navbar-brand href="#">Filter/Search</b-navbar-brand>
                            <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down	"></i></b-navbar-toggle>
                            <b-collapse id="nav-collapse" is-nav>
                                <div class="search-wrapper col-12">
                                    <div class="row col-12 override-padding">
                 <div class="col-lg-3 col-md-3 col-3">
                  <b-form-select class="input-text" v-model="search_unit_type" :options="unitTypeOptions" ></b-form-select>
                  </div>
                                        <div class="col-lg-3 col-md-3 col-3">
                                            <b-form-input
                                            class="input-text"
                                            v-model="search_name"
                                            type="text"
                                            placeholder="License Name"
                                            ></b-form-input>
                                        </div>
                                        <div class="col-lg-3 col-md-3 col-3">
                                            <b-form-select class="input-text" v-model="search_validity_duration" :options="validityDurationOptions"></b-form-select>
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-2">
                                            <b-form-select class="input-text" v-model="search_is_active" :options="packageStatusOptions"></b-form-select>
                                        </div>
                                        <div class="col-lg-1 col-md-1 col-1 search-icon-wrapper cursor-pointer" @click="filterPackagelistitems()">
                                            <span class="search-icon">
                                            <i class="fa fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </b-navbar>
                    </div>
                    <div class="margin-bottom-10"></div>
                    <div>
                        <b-card no-body>
                            <div class="row tasks_heading_row">
                                <div
                                    class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3"
                                    v-on:click="sortMethod('unitType')"
                                    >
                                    Unit Type
                                    <i v-if="sortField == 'unitType' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                    <i v-if="sortField == 'unitType' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                </div>
                                <div
                                    class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3"
                                    v-on:click="sortMethod('licenseType')"
                                    >
                                    License Type
                                    <i v-if="sortField == 'licenseType' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                    <i v-if="sortField == 'licenseType' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                </div>
                                <div
                                    class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                                    v-on:click="sortMethod('name')"
                                    >
                                    License Name
                                    <i v-if="sortField == 'name' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                    <i v-if="sortField == 'name' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                </div>
                                <div
                                    class="bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"                                    
                                    >
                                    Price                                    
                                </div>                                
                                <div
                                    class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                                    v-on:click="sortMethod('validityDuration')"
                                    >
                                    Validity Duration
                                    <i v-if="sortField == 'validityDuration' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                    <i v-if="sortField == 'validityDuration' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                </div>
                                <div
                                    class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                                    v-on:click="sortMethod('isActive')"
                                    >
                                    Status
                                    <i v-if="sortField == 'isActive' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                    <i v-if="sortField == 'isActive' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                            <b-card-text v-if="package_lists.length > 0">
                                <div v-for="(packagelist, index) in package_lists" class="tasklist-row">
                                    <div class="row tasklist-item"  style="margin: 0;">
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 package-name">{{packagelist.unitType}}</div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 package-name">{{packagelist.licenseType}}</div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">{{packagelist.licenseName}}</div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding" v-if="packagelist.licenseType == 'Bundle License'"><i class="fa fa-dollar"></i>{{ formatNumber(packagelist.bundlePrice) }}</div> 
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding" v-else-if="packagelist.unitType == 'Seat'">Starts with <i class="fa fa-dollar"></i>{{ formatNumber(packagelist.startingSeatPrice) }}</div> 

                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding" v-else-if="packagelist.price != null"><i class="fa fa-dollar"></i>{{ formatNumber(packagelist.price) }}</div> 
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding" v-else>Starts with <i class="fa fa-dollar"></i>{{ formatNumber(packagelist.startingPrice) }}</div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">{{getValidityDuration(packagelist.validityDuration)}}</div>
                                        <div class="col-xl-1 col-lg-1 col-md-2 col-sm-2 col-2 override-padding">{{getStatus(packagelist.isActive)}}</div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding">
                                            <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')">
                                                <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index">
                                                    <li></li>
                                                    <li></li>
                                                    <li></li>
                                                </ul>
                                                <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                                                    <div class="action-dd-menu"  @click="goToEdit(packagelist)"><i class="cursor-pointer fa fa-edit spacer-icon"></i>Edit</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div><hr></div>
                                </div>
                                <div v-if="rows > 25" class="overflow-auto float-right pagination-wrapper">
                                    <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                    first-text="First"
                                    prev-text="Prev"
                                    next-text="Next"
                                    last-text="Last"
                                    :hide-goto-end-buttons=false
                                    @input="showPackageofPaginated()"
                                    ></b-pagination>
                                </div>
                            </b-card-text>
                            <b-card-text v-else-if="loading == false">
                                    No Package found.
                            </b-card-text>
                        </b-card>
                    </div>
                </div>



                <CreateSubscriptionModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
                    <span v-if="loading" class="pull-right text-danger">
                    Loading...
                    </span>
                    <div slot="header" class="sub-heading"><h3>Create Purchase Type</h3></div>
                    <div slot="body" v-if="isModalVisible === true">
                        <div class="col-lg-12 col-12 override-padding">
                            <b-form-select class="input-text" v-model="unit_type" :options="unitTypeOptions"
                                v-validate="'required'"
                                name="Unit Type" @change="unitTypeChange()"
                            ></b-form-select>
                            
                            <div v-if="verrors.firstByRule('Unit Type', 'required')" class="margin-bottom-5 validate-warning-msg">Unit Type is required</div>
                        </div>
                        <div style="clear: both;" class="margin-bottom-10"></div>
                        <div v-if="unit_type == 'License'" class="col-lg-12 col-12 override-padding">
                            <b-form-select class="input-text" v-model="license_type" :options="licenseTypeOptions"
                                v-validate="'required'"
                                name="License Type"
                            ></b-form-select>
                            
                            <div v-if="verrors.firstByRule('License Type', 'required')" class="margin-bottom-5 validate-warning-msg">License Type is required</div>
                        </div>
                        <div style="clear: both;" class="margin-bottom-10"></div>
                        <div class="col-lg-12 col-12 override-padding" v-if="unit_type == 'License' || unit_type == 'Seat'">
                            <input v-model="license_name"
                                placeholder="License Name"
                                class="col-12 input-text form-control"
                                v-validate="'required'"
                                name="License Name" maxlength="150"
                                />
                                <div v-if="verrors.firstByRule('License Name', 'required')" class="margin-bottom-5 validate-warning-msg">License Name is required</div>                               
                        </div>
                        <div style="clear: both;" ></div>
                        <div class="col-lg-12 col-12 override-padding" v-if="unit_type ==  'One Time Purchase'">
                            <input v-model="price_onetime"
                                placeholder="Price"
                                class="col-12 input-text form-control"
                                v-validate="'required'"
                                name="Price" maxlength="8" @blur="formatOneTimePrice($event, 'add')"
                                />
                                <div v-if="verrors.firstByRule('Price', 'required')" class="margin-bottom-5 validate-warning-msg">Price is required</div>                               
                        </div>

                        <div class="col-lg-12 col-12 override-padding mt-2" v-if="unit_type ==  'License' && license_type == 'Bundle License'">
                          <div class="col-8 p-0 float-left">
                            <div class="col-12 p-0">
                              <div class="col-7 p-0 float-left" style="margin-top: 5px;">
                                Minimum License: 
                              </div>
                              <div class="col-5 p-0 float-left">
                              <input v-model="license_qty"
                                placeholder="Quantity"
                                class="col-12 input-text form-control"
                                v-validate="'required|numeric'"
                                name="License Quantity" maxlength="2" 
                                />
                                <div v-if="verrors.firstByRule('License Quantity', 'required')" class="margin-bottom-5 validate-warning-msg">Minimum Quantity is required</div>
                                <div v-else-if="verrors.firstByRule('License Quantity', 'numeric')" class="margin-bottom-5 validate-warning-msg">Minimum Quantity should be numeric</div>

                              </div>
                              <div style="clear: both;" class="margin-bottom-20"></div>
                              <div class="col-12 p-0">
                                Price per license (After Bundle):
                              </div>
                            </div>
                          </div>
                          <div class="col-4 p-0 float-left" style="padding-left: 15px !important;" >
                            <div class="col-12 p-0 text-align-right">
                              $ <input v-model="bundle_price"
                                placeholder="Price"
                                class="col-10 input-text form-control license-range-price"
                                v-validate="'required|decimal:2'"
                                name="Price Bundle" maxlength="8" @blur="formatBundlePrice($event, 'add')"
                                />
                                <div v-if="verrors.firstByRule('Price Bundle', 'required')" class="text-left margin-bottom-5 validate-warning-msg">Bundle Price is required</div>        
                                <div v-else-if="verrors.firstByRule('Price Bundle', 'decimal')" class="text-left margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>

                              </div>
                            <div class="col-12 p-0 text-align-right" style="margin-top: 10px;">
                              $ <input v-model="price_after_bundle"
                                placeholder="Price"
                                class="col-10 input-text form-control license-range-price"
                                v-validate="'required|decimal:2'"
                                name="Price After Bundle" maxlength="8" @blur="formatPriceAfterBundle($event, 'add')"
                                />
                                <div v-if="verrors.firstByRule('Price After Bundle', 'required')" class="text-left margin-bottom-5 validate-warning-msg">Price is required</div>         
                                <div v-else-if="verrors.firstByRule('Price After Bundle', 'decimal')" class="text-left margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>

                              </div>
                          </div>

                        </div>

                        <div style="clear: both;" ></div>



                        <div class="col-lg-12 col-12 override-padding mt-2" v-for="(list, pindex in priceTier" :key="pindex" v-if="unit_type == 'License' && license_type == 'Normal License'">
                            <input v-model="list.license_from"
                                placeholder=""
                                class="input-text form-control license-range-input" 
                                v-validate="'required|numeric'"
                                v-bind:name="'rangeFrom[' + pindex + ']'" maxlength="4"
                                @blur="checkPriceRangeNumbers(pindex, 'From')"
                                />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#x2015;&nbsp;&nbsp;&nbsp;&nbsp;
                                <input v-model="list.license_to"
                                placeholder=""
                                class="input-text form-control license-range-input" 
                                v-validate="'required|numeric'"
                                v-bind:name="'rangeTo[' + pindex + ']'" maxlength="4" 
                                @blur="checkPriceRangeNumbers(pindex, 'To')"                             
                                />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                $ <input v-model="list.license_price"
                                placeholder="Price"
                                v-bind:name="'price[' + pindex + ']'"
                                id="price1"
                                class="col-3 input-text form-control license-range-price"
                                v-validate="'required|decimal:2'" maxlength="8" @blur="formatPrice($event, pindex)"                              
                                />
                                <span class="delete-icon">
                                  <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removePriceTier(pindex)"></i>
                                </span>
                            
                            <div class="row">  
                                <div v-if="verrors.firstByRule('rangeFrom[' + pindex + ']', 'required')" class="col-4 margin-bottom-5 validate-warning-msg">Range From is required</div>
                                <div v-else-if="verrors.firstByRule('rangeFrom[' + pindex + ']', 'numeric')" class="col-4 margin-bottom-5 validate-warning-msg">Range From should be numeric</div>
                                <div v-else class="col-4 margin-bottom-5">&nbsp;</div>
                                <div v-if="verrors.firstByRule('rangeTo[' + pindex + ']', 'required')" class="col-4 margin-bottom-5 validate-warning-msg">Range To is required</div>
                                <div v-else-if="verrors.firstByRule('rangeTo[' + pindex + ']', 'numeric')" class="col-4 margin-bottom-5 validate-warning-msg">Range To should be numeric</div>
                                <div v-else class="col-4 margin-bottom-5">&nbsp;</div>
                                <div v-if="verrors.firstByRule('price[' + pindex + ']', 'required')" class="col-4 margin-bottom-5 validate-warning-msg"> Price is required</div>                                
                                <div v-else-if="verrors.firstByRule('price[' + pindex + ']', 'decimal')" class="col-4 margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                                <div v-else class="col-4 margin-bottom-5">&nbsp;</div>
                            </div>
                        </div>     
                                
                        <div style="clear: both;" ></div>
                        
                        <div class="float-right price-range-wrapper" v-on:click="addMorePriceTier()" v-if="unit_type == 'License' && license_type == 'Normal License'"> + Add License Price Range</div>
                        <div style="clear: both;" class="margin-bottom-10"></div>
                            <div class="col-lg-12 col-12 override-padding" v-if="unit_type == 'One Time Purchase'">
                            <b-form-select class="input-text" v-model="account_type" :options="accountTypeOptions"
                                v-validate="'required'"
                                name="Account Type"
                            ></b-form-select>
                            <div v-if="verrors.firstByRule('Account Type', 'required')" class="margin-bottom-5 validate-warning-msg">Account Type is required</div>
                        </div>
                        


                        <div class="col-lg-12 col-12 override-padding mt-2" v-for="(list, sindex) in seatPrice" :key="sindex" v-if="unit_type == 'Seat'">
                          <div class="row">
                            <div class="col-3">
                            <input v-model="list.package_name"
                            placeholder="Bundle Name"
                            v-bind:name="'package[' + sindex + ']'"
                            id="'package_' + sindex"
                            class="col-12 input-text form-control seat-package-name"
                            v-validate="'required'" maxlength="100" 
                            />
                            </div>
                            <div class="col-3 p-0 pr-2" v-if="list.unlimited == true">
                            <b-form-select class="input-text form-control col-12 seat-range-input" v-model="list.license_qty" :options="seatOptions"
                                v-validate="'required'"
                                v-bind:name="'qty[' + sindex + ']'"
                                v-bind:id="'qty_' + sindex" disabled="true"
                                @change="checkSeatPriceQty(sindex)"
                            ></b-form-select>
                            </div>
                            <div class="col-3 p-0 pr-2" v-else>
                            <b-form-select class="input-text form-control col-12 seat-range-input" v-model="list.license_qty" :options="seatOptions"
                                v-validate="'required'"
                                v-bind:name="'qty[' + sindex + ']'"
                                v-bind:id="'qty_' + sindex" 
                                @change="checkSeatPriceQty(sindex)"
                            ></b-form-select>
                            </div>
                            <div class="col-3 p-0 pr-2">
                            $ <input v-model="list.license_yearly_price"
                            placeholder="Yearly Price"
                            v-bind:name="'yearly_price[' + sindex + ']'"
                            id="price1"
                            class="col-11 input-text form-control seat-range-price"
                            v-validate="'required|decimal:2'" maxlength="8" @blur="formatSeatPrice($event, sindex, 'yearly')"                              
                            />
                            </div>
                            <div class="col-3 p-0" style="padding-right: 15px !important;">
                            $ <input v-model="list.license_monthly_price"
                            placeholder="Monthly Price"
                            v-bind:name="'monthly_price[' + sindex + ']'"
                            id="price2"
                            class="col-11 input-text form-control seat-range-price"
                            v-validate="'required|decimal:2'" maxlength="8" @blur="formatSeatPrice($event, sindex, 'monthly')"                              
                            />

                            </div>
                          </div>
                          <div class="row">  
                            <div v-if="verrors.firstByRule('package[' + sindex + ']', 'required')" class="col-3 margin-bottom-5 validate-warning-msg">Package Name is required</div>
                            <div v-else class="col-3 margin-bottom-5">&nbsp;</div>
                            <div v-if="verrors.firstByRule('qty[' + sindex + ']', 'required')" class="col-3 p-0 margin-bottom-5 validate-warning-msg">No of Seat is required</div>
                            <div v-else class="col-3 p-0 margin-bottom-5">&nbsp;</div>
                            <div v-if="verrors.firstByRule('yearly_price[' + sindex + ']', 'required')" class="col-3 margin-bottom-5 validate-warning-msg"> Price is required</div>
                            <div v-else-if="verrors.firstByRule('yearly_price[' + sindex + ']', 'decimal')" class="col-3 margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                            <div v-else class="col-3 margin-bottom-5">&nbsp;</div>

                            <div v-if="verrors.firstByRule('monthly_price[' + sindex + ']', 'required')" class="col-3 margin-bottom-5 validate-warning-msg">Price is required</div>
                            <div v-else-if="verrors.firstByRule('monthly_price[' + sindex + ']', 'decimal')" class="col-3 margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                            <div v-else class="col-3 margin-bottom-5">&nbsp;</div>

                          </div>

                          <div class="row">
                            <div class="col-3 pt-2">
                            
                                <div class="search-padd"  style="display: inline;">
                                  <input
                                      type="checkbox"
                                      v-bind:id="'unlimited_' + sindex"
                                      ref="unlimited"
                                      v-bind:name="'unlimited[' + sindex + ']'"
                                      v-model="list.unlimited" 
                                      @click="changeUnlimited(sindex, $event)"
                                      value="1" > 
                                </div>
                                <div style="display: inline;">Unlimited </div>

                            </div>
                            <div class="col-3 p-0 pr-2" v-if="list.unlimited == true">
                            <input v-model="list.max_limit_qty"
                            placeholder="Max seat limit"
                            v-bind:name="'max_seat[' + sindex + ']'"
                            id="'max_seat_' + sindex" disabled="true"
                            class="input-text form-control seat-range-package"
                            v-validate="'required|numeric'" maxlength="5" 
                            />

                            </div>
                            <div class="col-3 p-0 pr-2" v-else>
                            <input v-model="list.max_limit_qty"
                            placeholder="Max seat limit"
                            v-bind:name="'max_seat[' + sindex + ']'"
                            id="'max_seat_' + sindex"
                            class="input-text form-control seat-range-package"
                            v-validate="'required|numeric'" maxlength="5" 
                            />

                            </div>
                            
                            <div class="col-3 p-0 pr-2">
                            <input v-model="list.package_discount"
                            placeholder="Discount Percent"
                            v-bind:name="'package_discount[' + sindex + ']'"
                            id="'package_discount_' + sindex"
                            class="input-text form-control seat-range-package" v-validate="'numeric'"
                             maxlength="5" 
                            />
                            </div>
                            <div class="col-3 p-0" style="padding-right: 15px !important;">
                              <span class="delete-icon">
                              <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeSeat(sindex)"></i>
                              </span>
                            </div>
                          </div>
                          <div class="row">  
                            <div class="col-3 p-0 margin-bottom-5">&nbsp;</div>
                            <div v-if="verrors.firstByRule('max_seat[' + sindex + ']', 'required')" class="col-3 p-0 margin-bottom-5 validate-warning-msg">Max seat limit is required</div>
                            <div v-else-if="verrors.firstByRule('max_seat[' + sindex + ']', 'numeric')" class="col-3 p-0 margin-bottom-5 validate-warning-msg">Max seat limit should be numeric</div>
                            <div v-else class="col-3 margin-bottom-5">&nbsp;</div>
                            <div v-if="verrors.firstByRule('package_discount[' + sindex + ']', 'numeric')" class="col-3 p-0 margin-bottom-5 validate-warning-msg">Discount should be numeric</div>
                            <div class="col-3 margin-bottom-5">&nbsp;</div>
                            <div class="col-3 margin-bottom-5">&nbsp;</div>
                          </div>

                        </div>     

                                
                        <div style="clear: both;" ></div>
                        
                        <div class="mb-2 float-right price-range-wrapper" v-on:click="addMoreSeat()" v-if="(unit_type == 'Seat' && !checkAddUnlimited)" style="cursor: pointer;"> + Add More Bundles</div>

                        <div style="clear: both;" ></div>
                        <div class="mt-3 mb-3 py-2 px-3 subscription_box rounded shadow" v-if="unit_type == 'Seat'">
                          <div class="row">
                            <div class="col-12 pr-0 bold pb-3">
                              Additional Seat Price
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-2 pr-0 pt-2">
                                Yearly:
                            </div>
                            <div class="col-4 pl-0" v-if="checkAddUnlimited">
                            $ <input v-model="additional_seat_price_yearly"
                            placeholder="Price"
                            class="col-11 input-text form-control license-range-price"
                            v-validate="'required|decimal:2'"  disabled="true"
                            name="yearly_seat_price" maxlength="8" @blur="formatSeatAdditionalPrice($event, 'add', 'yearly')" style="max-width: 78%;"
                            />
                            <div v-if="verrors.firstByRule('yearly_seat_price', 'required')" class="text-left margin-bottom-5 validate-warning-msg">Price is required</div>         
                            <div v-else-if="verrors.firstByRule('yearly_seat_price', 'decimal')" class="text-left margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                            </div>
                            <div class="col-4 pl-0" v-else>
                            $ <input v-model="additional_seat_price_yearly"
                            placeholder="Price"
                            class="col-11 input-text form-control license-range-price"
                            v-validate="'required|decimal:2'"
                            name="yearly_seat_price" maxlength="8" @blur="formatSeatAdditionalPrice($event, 'add', 'yearly')" style="max-width: 78%;"
                            />
                            <div v-if="verrors.firstByRule('yearly_seat_price', 'required')" class="text-left margin-bottom-5 validate-warning-msg">Price is required</div>         
                            <div v-else-if="verrors.firstByRule('yearly_seat_price', 'decimal')" class="text-left margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                            </div>

                            <div class="col-2 pr-0 pt-2">
                                Monthly:
                            </div>
                            <div class="col-4 pl-0" v-if="checkAddUnlimited">
                            $ <input v-model="additional_seat_price_monthly"
                            placeholder="Price"
                            class="col-11 input-text form-control license-range-price"
                            v-validate="'required|decimal:2'" disabled="true"
                            name="monthly_seat_price" maxlength="8" @blur="formatSeatAdditionalPrice($event, 'add', 'monthly')" style="max-width: 78%;"
                            />
                            <div v-if="verrors.firstByRule('monthly_seat_price', 'required')" class="text-left margin-bottom-5 validate-warning-msg">Price is required</div>         
                            <div v-else-if="verrors.firstByRule('monthly_seat_price', 'decimal')" class="text-left margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                            </div>
                            <div class="col-4 pl-0" v-else>
                            $ <input v-model="additional_seat_price_monthly"
                            placeholder="Price"
                            class="col-11 input-text form-control license-range-price"
                            v-validate="'required|decimal:2'"
                            name="monthly_seat_price" maxlength="8" @blur="formatSeatAdditionalPrice($event, 'add', 'monthly')" style="max-width: 78%;"
                            />
                            <div v-if="verrors.firstByRule('monthly_seat_price', 'required')" class="text-left margin-bottom-5 validate-warning-msg">Price is required</div>         
                            <div v-else-if="verrors.firstByRule('monthly_seat_price', 'decimal')" class="text-left margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                            </div>


                          </div>

                        </div>







                       
                        <div class="mt-2 col-lg-12 col-12 override-padding">
                        <div class="search-padd" id="purchase-type-wrapper"  v-if="unit_type !=  ''">
                            <multiselect
                            v-model="affiliate_selected"
                            :options="affiliate_options" track-by="name" label="name"
                            placeholder="Select Affiliates..." :multiple="true"  :close-on-select="false" :show-labels="false"
                            v-validate="'required'"
                            name="affiliate"
                            id="affiliate">
                             <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                           </multiselect>                                
                            <div v-if="verrors.firstByRule('affiliate', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate is required</div>
                           </div> 
                        </div>
                        <div style="clear: both;" class="margin-bottom-10"></div>
                        <div class="col-lg-12 col-12 override-padding" v-if="unit_type == 'License'">
                            <b-form-select class="input-text" v-model="package_validity_duration" :options="validityDurationOptions"
                                v-validate="'required'"
                                name="Validity Duration"
                            ></b-form-select>
                            <div v-if="verrors.firstByRule('Validity Duration', 'required')" class="margin-bottom-5 validate-warning-msg">Validity Duration is required</div>
                        </div>
                        <div class="col-lg-12 col-12 override-padding" v-if="unit_type == 'Seat'">
                            <b-form-select class="input-text" v-model="package_validity_duration" :options="seatValidityDurationOptions"
                                v-validate="'required'"
                                name="Validity Duration"
                            ></b-form-select>
                            <div v-if="verrors.firstByRule('Validity Duration', 'required')" class="margin-bottom-5 validate-warning-msg">Validity Duration is required</div>
                        </div>
                        <div style="clear: both;" v-if="unit_type == 'License' || unit_type == 'Seat'" class="margin-bottom-10"></div>
                        <div class="col-lg-12 col-12 override-padding" v-if="unit_type !=  ''">
                            <b-form-select class="input-text" v-model="package_is_active" :options="packageStatusOptions"
                                v-validate="'required'"
                                name="Status"
                            ></b-form-select>
                            <div v-if="verrors.firstByRule('Status', 'required')" class="margin-bottom-5 validate-warning-msg">Status is required</div>
                        </div>

                        <div class="license-criteria-wrapper" v-if="(unit_type == 'License') && (package_is_active == '1')" >
                        <div class="license-criteria-heading">License Redistribution Criteria</div>
                        <div class="col-lg-12 col-12 override-padding">
                            <input v-model="probation_window"
                                placeholder="Probation"
                                class="input-text form-control license-range-input"
                                v-validate="'required|numeric'"
                                name="Probation Window" maxlength="3"
                                /> days 
                                <span style="margin-right:40px;"></span>
                                <input v-model="reassign_window"
                                placeholder="Reassign"
                                class="input-text form-control license-range-input"
                                v-validate="'required|numeric'"
                                name="Reassign Window" maxlength="3"
                                /> days 
                                <span style="margin-right:30px;"></span>
                                <input v-model="no_of_reassign"
                                placeholder="#"
                                class="input-text form-control license-range-input"
                                v-validate="'required|numeric'"
                                name="No Of Reassign" maxlength="1"
                                />                                                          
                         </div>
                         <div class="col-lg-12 col-12 override-padding license-criteria-label" >
                            <span class="license-criteria-label">Probation Window </span>
                            <span style="margin-right:60px;"></span>
                            <span class="license-criteria-label">Reassign Window </span>
                            <span style="margin-right:40px;"></span>
                            <span class="license-criteria-label"># of Reassigns</span>
                         </div>
                         <div style="clear: both;" class="margin-bottom-10"></div>
                            <div class="row">  
                                <div v-if="verrors.firstByRule('Probation Window', 'required')" class="col-4 margin-bottom-5 validate-warning-msg">Probation Window is required</div>
                                <div v-else-if="verrors.firstByRule('Probation Window', 'numeric')" class="col-4 margin-bottom-5 validate-warning-msg">Probation Window should be numeric</div>
                                <div v-else class="col-4 margin-bottom-5">&nbsp;</div>
                                <div v-if="verrors.firstByRule('Reassign Window', 'required')" class="col-4 margin-bottom-5 validate-warning-msg">Reassign Window is required</div>
                                <div v-else-if="verrors.firstByRule('Reassign Window', 'numeric')" class="col-4 margin-bottom-5 validate-warning-msg">Reassign Window should be numeric</div>
                                <div v-else class="col-4 margin-bottom-5">&nbsp;</div>
                                <div v-if="verrors.firstByRule('No Of Reassign', 'required')" class="col-4 margin-bottom-5 validate-warning-msg"> No Of Reassign is required</div>                                
                                <div v-else-if="verrors.firstByRule('No Of Reassign', 'numeric')" class="col-4 margin-bottom-5 validate-warning-msg">No Of Reassign should be numeric</div>
                                <div v-else class="col-4 margin-bottom-5">&nbsp;</div>
                            </div>
                        </div> 

                        <div style="clear: both;" class="margin-bottom-10"></div>
                        <div class="col-12 override-padding">
                            <button
                                v-on:click="createPackageAction()"
                                class="btn btn-red col-3 float-left input-height-25"
                                ><b>Create</b></button>
                        </div>
                    </div>
                    <div slot="footer" class="col-3 override-padding"></div>
                </CreateSubscriptionModal>

                <EditSubscriptionModal :isModalVisible="isEditModalVisible" :editId="editId" @close="isEditModalVisible = false">
               
                  <div slot="header" class="sub-heading"><h3>Edit Purchase Type</h3></div>
                   
                  <div slot="body" v-if="isEditModalVisible === true">
                            <div class="col-lg-12 col-12 override-padding">
                                <b-form-select class="input-text" v-model="edit_unit_type" :options="editUnitTypeOptions"
                                    v-validate="'required'"
                                    name="Unit Type"
                                ></b-form-select>
                                
                                <div v-if="verrors.firstByRule('Unit Type', 'required')" class="margin-bottom-5 validate-warning-msg">Unit Type is required</div>
                            </div>


                            <div style="clear: both;" class="margin-bottom-10"></div>

                        <div v-if="edit_unit_type == 'License'" class="col-lg-12 col-12 override-padding">
                            <b-form-select class="input-text" v-model="edit_license_type" :options="licenseTypeOptions"
                                v-validate="'required'"
                                name="License Type"
                            ></b-form-select>
                            
                            <div v-if="verrors.firstByRule('License Type', 'required')" class="margin-bottom-5 validate-warning-msg">License Type is required</div>
                        </div>
                        <div style="clear: both;" class="margin-bottom-10"></div>

                            <div class="col-lg-12 col-12 override-padding" v-if="edit_unit_type == 'License'  || edit_unit_type == 'Seat'">
                                <input v-model="edit_license_name"
                                    placeholder="License Name"
                                    class="col-12 input-text form-control"
                                    v-validate="'required'"
                                    name="License Name"
                                    maxlength="150"
                                    />
                                    <div v-if="verrors.firstByRule('License Name', 'required')" class="margin-bottom-5 validate-warning-msg">License Name is required</div>                               
                            </div>
                            <div style="clear: both;" class="margin-bottom-10"></div>
                            <div class="col-lg-12 col-12 override-padding" v-if="edit_unit_type ==  'One Time Purchase'">
                                <input v-model="edit_price_onetime"
                                    placeholder="Price"
                                    class="col-12 input-text form-control"
                                    v-validate="'required'"
                                    name="Price" @blur="formatOneTimePrice($event, 'edit')" maxlength="8"
                                    />
                                    <div v-if="verrors.firstByRule('Price', 'required')" class="margin-bottom-5 validate-warning-msg">Price is required</div>                               
                            </div>
                            <div style="clear: both;" class="margin-bottom-10"></div>


                        <div class="col-lg-12 col-12 override-padding" v-if="edit_unit_type ==  'License' && edit_license_type == 'Bundle License'">
                          <div class="col-8 p-0 float-left">
                            <div class="col-12 p-0">
                              <div class="col-7 p-0 float-left" style="margin-top: 5px;">
                                Minimum License: 
                              </div>
                              <div class="col-5 p-0 float-left">
                              <input v-model="edit_license_qty"
                                placeholder="Quantity"
                                class="col-12 input-text form-control"
                                v-validate="'required|numeric'"
                                name="License Quantity" maxlength="2" 
                                />
                                <div v-if="verrors.firstByRule('License Quantity', 'required')" class="margin-bottom-5 validate-warning-msg">Minimum Quantity is required</div>         
                                <div v-else-if="verrors.firstByRule('License Quantity', 'numeric')" class="margin-bottom-5 validate-warning-msg">Minimum Quantity should be numeric</div>

                              </div>
                              <div style="clear: both;" class="margin-bottom-20"></div>
                              <div class="col-12 p-0">
                                Price per license (After Bundle):
                              </div>
                            </div>
                          </div>
                          <div class="col-4 p-0 float-left" style="padding-left: 15px !important;" >
                            <div class="col-12 p-0 text-align-right">
                              $ <input v-model="edit_bundle_price"
                                placeholder="Price"
                                class="col-10 input-text form-control license-range-price"
                                v-validate="'required|decimal:2'"
                                name="Price Bundle" maxlength="8" @blur="formatBundlePrice($event, 'edit')" 
                                />
                                <div v-if="verrors.firstByRule('Price Bundle', 'required')" class="text-left margin-bottom-5 validate-warning-msg">Bundle Price is required</div>         
                                <div v-else-if="verrors.firstByRule('Price Bundle', 'decimal')" class="text-left margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                              </div>
                            <div class="col-12 p-0 text-align-right" style="margin-top: 10px;">
                              $ <input v-model="edit_price_after_bundle"
                                placeholder="Price"
                                class="col-10 input-text form-control  license-range-price"
                                v-validate="'required||decimal:2'"
                                name="Price After Bundle" maxlength="8" @blur="formatPriceAfterBundle($event, 'edit')" 
                                />
                                <div v-if="verrors.firstByRule('Price After Bundle', 'required')" class="text-left margin-bottom-5 validate-warning-msg">Price is required</div>         
                                <div v-else-if="verrors.firstByRule('Price After Bundle', 'decimal')" class="text-left margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                              </div>
                          </div>

                        </div>

                        <div style="clear: both;" class="margin-bottom-10"></div>


                            <div class="col-lg-12 col-12 override-padding" v-for="(list, pindex in editPriceTier" :key="pindex" v-if="edit_unit_type == 'License' && edit_license_type == 'Normal License'">
                                <input type="hidden" v-model="list.license_id" v-bind:name="'licenseId[' + pindex + ']'" >
                                <input v-model="list.license_from"
                                    placeholder=""
                                    class="input-text form-control license-range-input" 
                                    v-validate="'required|numeric'"
                                     v-bind:name="'rangeFrom[' + pindex + ']'"
                                     @blur="editCheckPriceRangeNumbers(pindex, 'From')" maxlength="4"
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#x2015;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <input v-model="list.license_to"
                                    placeholder=""
                                    class="input-text form-control license-range-input" 
                                    v-validate="'required|numeric'"
                                    v-bind:name="'rangeTo[' + pindex + ']'"
                                    @blur="editCheckPriceRangeNumbers(pindex, 'To')" maxlength="4"                               
                                    />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    $ <input v-model="list.license_price"
                                    placeholder="Price"
                                    v-bind:name="'price[' + pindex + ']'"
                                    class="col-4 input-text form-control license-range-price"
                                    v-validate="'required|decimal:2'" @blur="formatEditPrice($event, pindex)"  maxlength="8"                             
                                    />

                                <div class="row">  
                                    <div v-if="verrors.firstByRule('rangeFrom[' + pindex + ']', 'required')" class="col-4 margin-bottom-5 validate-warning-msg">Range From is required</div>
                                    <div v-else-if="verrors.firstByRule('rangeFrom[' + pindex + ']', 'numeric')" class="col-4 margin-bottom-5 validate-warning-msg">Range From should be numeric</div>
                                    <div v-else class="col-4 margin-bottom-5">&nbsp;</div>
                                    <div v-if="verrors.firstByRule('rangeTo[' + pindex + ']', 'required')" class="col-4 margin-bottom-5 validate-warning-msg">Range To is required</div>
                                    <div v-else-if="verrors.firstByRule('rangeTo[' + pindex + ']', 'numeric')" class="col-4 margin-bottom-5 validate-warning-msg">Range To should be numeric</div>
                                    <div v-else class="col-4 margin-bottom-5">&nbsp;</div>
                                    <div v-if="verrors.firstByRule('price[' + pindex + ']', 'required')" class="col-4 margin-bottom-5 validate-warning-msg"> Price is required</div>                                
                                    <div v-else-if="verrors.firstByRule('price[' + pindex + ']', 'decimal')" class="col-4 margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                                    <div v-else class="col-4 margin-bottom-5">&nbsp;</div>
                                </div> 
                                    
                            </div>
                                   

                            <div class="float-right price-range-wrapper" v-on:click="addMorePriceTierOfEdit()" v-if="edit_unit_type == 'License' && edit_license_type == 'Normal License'"> + Add License Price Range</div>
                            <div style="clear: both;" class="margin-bottom-10"></div>
                             <div class="col-lg-12 col-12 override-padding" v-if="edit_unit_type == 'One Time Purchase'">
                                <b-form-select class="input-text" v-model="edit_account_type" :options="accountTypeOptions"
                                    v-validate="'required'"
                                    name="Account Type"
                                ></b-form-select>
                                <div v-if="verrors.firstByRule('Account Type', 'required')" class="margin-bottom-5 validate-warning-msg">Account Type is required</div>
                            </div>
                            <div style="clear: both;" class="margin-bottom-10"></div>


                        <div class="col-lg-12 col-12 override-padding mt-2" v-for="(list, sindex) in editseatPrice" :key="sindex" v-if="edit_unit_type == 'Seat'">
                          <div class="row">
                            <div class="col-3">
                            <input v-model="list.package_name"
                            placeholder="Package Name"
                            v-bind:name="'package[' + sindex + ']'"
                            id="'package_' + sindex"
                            class="col-12 input-text form-control seat-package-name"
                            v-validate="'required'" maxlength="100" 
                            />
                            </div>
                            <div class="col-3 p-0 pr-2" v-if="list.unlimited == true" >
                            <b-form-select class="input-text form-control col-12 seat-range-input" v-model="list.license_qty" :options="seatOptions"
                                v-validate="'required'"
                                v-bind:name="'qty[' + sindex + ']'"
                                v-bind:id="'qty_' + sindex" disabled="true"
                                @change="checkEditSeatPriceQty(sindex)"
                            ></b-form-select>
                            </div>
                            <div class="col-3 p-0 pr-2" v-else>
                            <b-form-select class="input-text form-control col-12 seat-range-input" v-model="list.license_qty" :options="seatOptions"
                                v-validate="'required'"
                                v-bind:name="'qty[' + sindex + ']'"
                                v-bind:id="'qty_' + sindex" 
                                @change="checkEditSeatPriceQty(sindex)"
                            ></b-form-select>
                            </div>
                            <div class="col-3 p-0 pr-2">
                            $ <input v-model="list.license_yearly_price"
                            placeholder="Yearly Price"
                            v-bind:name="'yearly_price[' + sindex + ']'"
                            id="price1"
                            class="col-11 input-text form-control seat-range-price"
                            v-validate="'required|decimal:2'" maxlength="8" @blur="formatEditSeatPrice($event, sindex, 'yearly')"                              
                            />
                            </div>
                            <div class="col-3 p-0" style="padding-right: 15px !important;">
                            $ <input v-model="list.license_monthly_price"
                            placeholder="Monthly Price"
                            v-bind:name="'monthly_price[' + sindex + ']'"
                            id="price2"
                            class="col-11 input-text form-control seat-range-price"
                            v-validate="'required|decimal:2'" maxlength="8" @blur="formatEditSeatPrice($event, sindex, 'monthly')"                              
                            />

                            </div>
                          </div>
                          <div class="row">  
                            <div v-if="verrors.firstByRule('package[' + sindex + ']', 'required')" class="col-3 margin-bottom-5 validate-warning-msg">Bundle Name is required</div>
                            <div v-else class="col-3 margin-bottom-5">&nbsp;</div>
                            <div v-if="verrors.firstByRule('qty[' + sindex + ']', 'required')" class="col-3 p-0 margin-bottom-5 validate-warning-msg">No of Seat is required</div>
                            <div v-else class="col-3 p-0 margin-bottom-5">&nbsp;</div>
                            <div v-if="verrors.firstByRule('yearly_price[' + sindex + ']', 'required')" class="col-3 margin-bottom-5 validate-warning-msg"> Price is required</div>
                            <div v-else-if="verrors.firstByRule('yearly_price[' + sindex + ']', 'decimal')" class="col-3 margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                            <div v-else class="col-3 margin-bottom-5">&nbsp;</div>

                            <div v-if="verrors.firstByRule('monthly_price[' + sindex + ']', 'required')" class="col-3 margin-bottom-5 validate-warning-msg">Price is required</div>
                            <div v-else-if="verrors.firstByRule('monthly_price[' + sindex + ']', 'decimal')" class="col-3 margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                            <div v-else class="col-3 margin-bottom-5">&nbsp;</div>

                          </div>

                          <div class="row">
                            <div class="col-3 pt-2" v-if="(list.license_id != '' && list.unlimited == true)">
                            
                                <div class="search-padd"  style="display: inline;" v-if="(list.license_id != '' && list.unlimited == true)">
                                  <input
                                      type="checkbox"
                                      v-bind:id="'unlimited_' + sindex"
                                      ref="unlimited"
                                      v-bind:name="'unlimited[' + sindex + ']'"
                                      v-model="list.unlimited" 
                                      @click="changeEditUnlimited(sindex, $event)"
                                      value="1" > 
                                </div>
                                <div style="display: inline;">Unlimited </div>

                            </div>
                            <div class="col-3" v-else>
                            </div>
                            <div class="col-3 p-0 pr-2" v-if="list.unlimited == true">
                            <input v-model="list.max_limit_qty"
                            placeholder="Max seat limit"
                            v-bind:name="'max_seat[' + sindex + ']'"
                            id="'max_seat_' + sindex" disabled="true"
                            class="input-text form-control seat-range-package"
                            v-validate="'required|numeric'" maxlength="5" 
                            />

                            </div>
                            <div class="col-3 p-0 pr-2" v-else>
                            <input v-model="list.max_limit_qty"
                            placeholder="Max seat limit"
                            v-bind:name="'max_seat[' + sindex + ']'"
                            id="'max_seat_' + sindex"
                            class="input-text form-control seat-range-package"
                            v-validate="'required|numeric'" maxlength="5" 
                            />

                            </div>

                            <div class="col-3 p-0 pr-2">
                            <input v-model="list.package_discount"
                            placeholder="Discount Percent"
                            v-bind:name="'package_discount[' + sindex + ']'"
                            id="'package_discount_' + sindex"
                            class="input-text form-control seat-range-package" v-validate="'numeric'"
                             maxlength="5" 
                            />
                            </div>
                            <div class="col-3 p-0" style="padding-right: 15px !important;">
                              &nbsp;
                            </div>
                          </div>
                          <div class="row">  
                            <div class="col-3 p-0 margin-bottom-5">&nbsp;</div>
                            <div v-if="verrors.firstByRule('max_seat[' + sindex + ']', 'required')" class="col-3 p-0 margin-bottom-5 validate-warning-msg">Max seat limit is required</div>
                            <div v-else-if="verrors.firstByRule('max_seat[' + sindex + ']', 'numeric')" class="col-3 p-0 margin-bottom-5 validate-warning-msg">Max seat limit should be numeric</div>
                            <div v-else class="col-3 margin-bottom-5">&nbsp;</div>
                            <div v-if="verrors.firstByRule('package_discount[' + sindex + ']', 'numeric')" class="col-3 p-0 margin-bottom-5 validate-warning-msg">Discount should be numeric</div>
                            <div class="col-3 margin-bottom-5">&nbsp;</div>
                            <div class="col-3 margin-bottom-5">&nbsp;</div>
                          </div>

                        </div>     

                                
                        <div style="clear: both;" ></div>
                        
                        <div class="mb-2 float-right price-range-wrapper" v-on:click="addEditMoreSeat()" v-if="(edit_unit_type == 'Seat' && !checkEditUnlimited)" style="cursor: pointer;"> + Add More Bundles</div>



                        <div style="clear: both;" ></div>
                        <div class="mt-3 mb-3 py-2 px-3 subscription_box rounded shadow" v-if="edit_unit_type == 'Seat' ">
                          <div class="row">
                            <div class="col-12 pr-0 bold pb-3">
                              Additional Seat Price
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-2 pr-0 pt-2">
                                Yearly:
                            </div>
                            <div class="col-4 pl-0" v-if="checkEditUnlimited">
                            $ <input v-model="edit_additional_seat_price_yearly"
                            placeholder="Price"
                            class="col-11 input-text form-control license-range-price"
                            v-validate="'required|decimal:2'" disabled="true"
                            name="yearly_seat_price" maxlength="8" @blur="formatSeatAdditionalPrice($event, 'add', 'yearly')" style="max-width: 78%;"
                            />
                            <div v-if="verrors.firstByRule('yearly_seat_price', 'required')" class="text-left margin-bottom-5 validate-warning-msg">Price is required</div>         
                            <div v-else-if="verrors.firstByRule('yearly_seat_price', 'decimal')" class="text-left margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                            </div>
                            <div class="col-4 pl-0" v-else>
                            $ <input v-model="edit_additional_seat_price_yearly"
                            placeholder="Price"
                            class="col-11 input-text form-control license-range-price"
                            v-validate="'required|decimal:2'" 
                            name="yearly_seat_price" maxlength="8" @blur="formatSeatAdditionalPrice($event, 'add', 'yearly')" style="max-width: 78%;"
                            />
                            <div v-if="verrors.firstByRule('yearly_seat_price', 'required')" class="text-left margin-bottom-5 validate-warning-msg">Price is required</div>         
                            <div v-else-if="verrors.firstByRule('yearly_seat_price', 'decimal')" class="text-left margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                            </div>

                            <div class="col-2 pr-0 pt-2">
                                Monthly:
                            </div>
                            <div class="col-4 pl-0"  v-if="checkEditUnlimited">
                            $ <input v-model="edit_additional_seat_price_monthly"
                            placeholder="Price"
                            class="col-11 input-text form-control license-range-price"
                            v-validate="'required|decimal:2'" disabled="true"
                            name="monthly_seat_price" maxlength="8" @blur="formatSeatAdditionalPrice($event, 'add', 'monthly')" style="max-width: 78%;"
                            />
                            <div v-if="verrors.firstByRule('monthly_seat_price', 'required')" class="text-left margin-bottom-5 validate-warning-msg">Price is required</div>         
                            <div v-else-if="verrors.firstByRule('monthly_seat_price', 'decimal')" class="text-left margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                            </div>
                            <div class="col-4 pl-0"  v-else>
                            $ <input v-model="edit_additional_seat_price_monthly"
                            placeholder="Price"
                            class="col-11 input-text form-control license-range-price"
                            v-validate="'required|decimal:2'"
                            name="monthly_seat_price" maxlength="8" @blur="formatSeatAdditionalPrice($event, 'add', 'monthly')" style="max-width: 78%;"
                            />
                            <div v-if="verrors.firstByRule('monthly_seat_price', 'required')" class="text-left margin-bottom-5 validate-warning-msg">Price is required</div>         
                            <div v-else-if="verrors.firstByRule('monthly_seat_price', 'decimal')" class="text-left margin-bottom-5 validate-warning-msg">Price should be numeric and may contain 2 decimal points</div>
                            </div>


                          </div>

                        </div>









                            <div class="col-lg-12 col-12 override-padding">
                            <div class="search-padd" id="purchase-type-wrapper"  v-if="edit_unit_type !=  ''">
                                <multiselect
                                v-model="edit_affiliate_selected"
                                :options="affiliate_options" track-by="name" label="name"
                                placeholder="Select Affiliates..." :multiple="true"  :close-on-select="false" :show-labels="false"
                                v-validate="'required'"
                                name="affiliate"
                                id="affiliate">
                                 <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                               </multiselect>                                
                                <div v-if="verrors.firstByRule('affiliate', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate is required</div>
                               </div> 
                            </div>
                            <div style="clear: both;" class="margin-bottom-10"></div>
                            <div class="col-lg-12 col-12 override-padding" v-if="(edit_unit_type == 'License')">
                                <b-form-select class="input-text" v-model="edit_validity_duration" :options="validityDurationOptions"
                                    v-validate="'required'"
                                    name="Validity Duration"
                                ></b-form-select>
                                <div v-if="verrors.firstByRule('Validity Duration', 'required')" class="margin-bottom-5 validate-warning-msg">Validity Duration is required</div>
                            </div>
                            <div class="col-lg-12 col-12 override-padding" v-if="(edit_unit_type == 'Seat')">
                                <b-form-select class="input-text" v-model="edit_validity_duration" :options="seatValidityDurationOptions"
                                    v-validate="'required'"
                                    name="Validity Duration"
                                ></b-form-select>
                                <div v-if="verrors.firstByRule('Validity Duration', 'required')" class="margin-bottom-5 validate-warning-msg">Validity Duration is required</div>
                            </div>
                            <div style="clear: both;" class="margin-bottom-10"></div>
                            <div class="col-lg-12 col-12 override-padding" v-if="edit_unit_type !=  ''">
                                <b-form-select class="input-text" v-model="edit_is_active" :options="packageStatusOptions"
                                    v-validate="'required'"
                                    name="Status"
                                ></b-form-select>
                                <div v-if="verrors.firstByRule('Status', 'required')" class="margin-bottom-5 validate-warning-msg">Status is required</div>
                            </div>

                            <div class="license-criteria-wrapper" v-if="(edit_unit_type == 'License') && (edit_is_active == '1')" >
                            <div class="license-criteria-heading">License Redistribution Criteria</div>
                            <div class="col-lg-12 col-12 override-padding">
                                <input v-model="edit_probation_window"
                                    placeholder=""
                                    class="input-text form-control license-range-input"
                                    v-validate="'required|numeric'"
                                    name="Probation Window" maxlength="3"
                                    /> days 
                                    <span style="margin-right:40px;"></span>
                                    <input v-model="edit_reassign_window"
                                    placeholder=""
                                    class="input-text form-control license-range-input"
                                    v-validate="'required|numeric'"
                                    name="Reassign Window" maxlength="3"
                                    /> days 
                                    <span style="margin-right:30px;"></span>
                                    <input v-model="edit_no_of_reassign"
                                    placeholder=""
                                    class="input-text form-control license-range-input"
                                    v-validate="'required|numeric'"
                                    name="No Of Reassign" maxlength="1"
                                    />                                                          
                             </div>
                             <div class="col-lg-12 col-12 override-padding license-criteria-label" >
                                <span class="license-criteria-label">Probation Window </span>
                                <span style="margin-right:60px;"></span>
                                <span class="license-criteria-label">Reassign Window </span>
                                <span style="margin-right:50px;"></span>
                                <span class="license-criteria-label"># of Reassigns</span>
                             </div>
                             <div style="clear: both;" class="margin-bottom-10"></div>
                                <div class="row">  
                                    <div v-if="verrors.firstByRule('Probation Window', 'required')" class="col-4 margin-bottom-5 validate-warning-msg">Probation Window is required</div>
                                    <div v-else-if="verrors.firstByRule('Probation Window', 'numeric')" class="col-4 margin-bottom-5 validate-warning-msg">Probation Window should be numeric</div>
                                    <div v-else class="col-4 margin-bottom-5">&nbsp;</div>
                                    <div v-if="verrors.firstByRule('Reassign Window', 'required')" class="col-4 margin-bottom-5 validate-warning-msg">Reassign Window is required</div>
                                    <div v-else-if="verrors.firstByRule('Reassign Window', 'numeric')" class="col-4 margin-bottom-5 validate-warning-msg">Reassign Window should be numeric</div>
                                    <div v-else class="col-4 margin-bottom-5">&nbsp;</div>
                                    <div v-if="verrors.firstByRule('No Of Reassign', 'required')" class="col-4 margin-bottom-5 validate-warning-msg"> No Of Reassign is required</div>                                
                                    <div v-else-if="verrors.firstByRule('No Of Reassign', 'numeric')" class="col-4 margin-bottom-5 validate-warning-msg">No Of Reassign should be numeric</div>
                                    <div v-else class="col-4 margin-bottom-5">&nbsp;</div>
                                </div>
                            </div> 
                        
                            <div style="clear: both;" class="margin-bottom-10"></div>
                        <div class="col-12 override-padding">
                            <button
                                v-on:click="updatePackage()"
                                class="btn btn-red col-3 float-left input-height-25"
                                ><b>Update</b></button>
                        </div>
                  
                     </div>
                    <div slot="footer" class="col-3 override-padding"></div>
                 
                </EditSubscriptionModal>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import CreateSubscriptionModal from './create-subscriptionlevel-modal.vue';
import EditSubscriptionModal from './edit-subscriptionlevel-modal.vue';
import router from '../../router/index.js';
import ValidationModal from '../shared/validation_modal_alert.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import Multiselect from 'vue-multiselect';

const customValidityDurationOptions = [
    { value: '', text: 'Select Validity Duration' },
    { value:'1', text: '1 Month' }, 
    { value:'3', text: '3 Months' },
    { value:'6', text: '6 Months' },
    { value:'12', text: '12 Months' },
    { value:'18', text: '18 Months' },
    { value:'24', text: '24 Months' },
    { value:'36', text: '36 Months' }
];
const customSeatValidityDurationOptions = [
    { value: '', text: 'Select Validity Duration' },
    { value:'12', text: '12 Months' },
];
const customPackageStatusOptions = [
    { value:'', text: 'Select Status' }, 
    { value:'1', text: 'Active' }, 
    { value:'0', text: 'Inactive' }
];
const customSeatOptions = [
    { value: '', text: 'Select Seat' },
    { value:'5', text: '5' }, 
    { value:'10', text: '10' }, 
    { value:'15', text: '15' }, 
    { value:'20', text: '20' }, 
];
const customUnitTypeOptions = [
    { value:'', text: 'Select Unit Type' }, 
    { value:'License', text: 'License' }, 
    { value:'One Time Purchase', text: 'One Time Purchase' },
    { value:'Seat', text: 'Seat' }, 
];
const customLicenseTypeOptions = [
    { value:'', text: 'Select License Type' }, 
    { value:'Normal License', text: 'Normal License' }, 
    { value:'Bundle License', text: 'Bundle License' }
];
const customAccountTypeOptions = [
    { value:'', text: 'Select Account Type' }, 
    { value:'Enterprise Account', text: 'Enterprise Account' }, 
    { value:'Single Account', text: 'Single Account' }
];
const customEditUnitTypeOptions = [
    { value:'License', text: 'License', disabled: true }, 
    { value:'Seat', text: 'Seat', disabled: true }, 
    { value:'One Time Purchase', text: 'One Time Purchase', disabled: true }
];


export default {
    data() {
        return {
            rows: 0,
            perPage: 25,
            currentPage: 1,
            package_lists: [],
            affiliate_selected: [],
            loading: false,
            sortField: '',
            isModalVisible: false,
            isEditModalVisible: false,
            validityDurationOptions: customValidityDurationOptions,
            seatValidityDurationOptions: customSeatValidityDurationOptions,
            packageStatusOptions: customPackageStatusOptions,
            unitTypeOptions: customUnitTypeOptions,
            licenseTypeOptions: customLicenseTypeOptions,
            seatOptions: customSeatOptions,
            accountTypeOptions: customAccountTypeOptions,
            package_validity_duration: '',
            editUnitTypeOptions:customEditUnitTypeOptions,
            affiliate_options: [],
            unit_type: '',
            license_type: '',
            package_is_active: '',           
            editId: '',
            search_is_active: '',
            search_name: '',
            search_validity_duration: '',
            license_price: '',
            license_from: '1',
            license_to: '999',
            license_name: '',
            probation_window: '',
            reassign_window: '',
            no_of_reassign: '',
            account_type: '',
            priceTier: [
              {
                license_from: '1',
                license_to: '999',
                license_price: '',
              }
            ],
            seatPrice: [
                {
                    package_name: '',
                    license_qty: '',
                    license_yearly_price: '',
                    license_monthly_price: '',
                    max_limit_qty: '',
                    package_discount: '',
                    unlimited: false,
                },
            ],
            additional_seat_price_yearly: '',
            additional_seat_price_monthly: '',
            editseatPrice: [
                {
                    package_name: '',
                    license_qty: '',
                    license_yearly_price: '',
                    license_monthly_price: '',
                    max_limit_qty: '',
                    package_discount: '',
                    unlimited: false,
                },
            ],
            edit_additional_seat_price_yearly: '',
            edit_additional_seat_price_monthly: '',
            price_onetime: '',
            edit_affiliate_selected: [],
            edit_unit_type: '',
            edit_license_price: '',
            edit_license_from: '1',
            edit_license_to: '999',
            edit_license_name: '',
            edit_probation_window: '',
            edit_reassign_window: '',
            edit_no_of_reassign: '',
            edit_account_type: '',
            edit_price_onetime: '',
            editPriceTier: [],
            edit_is_active: '',
            search_unit_type: '',
            bundle_price: '',
            price_after_bundle: '',
            license_qty: '',
            edit_license_type: '',
            edit_bundle_price: '',
            edit_price_after_bundle: '',
            edit_license_qty: '',
        }
    },
    components: {
        UserMenu,
        GoBack,
        ValidationModal,
        DeleteModal,
        CreateSubscriptionModal,
        EditSubscriptionModal,
        Multiselect,        
        MasteradminSidebarMenu
    },
    computed: {
      checkEditUnlimited(){
        var flag = 0;
        for(var i=0; i<this.editseatPrice.length; i++) {
          if(this.editseatPrice[i].unlimited == true) {
            flag = 1;
          }
        }
        if(flag == 1) {
          return true;
        }
        else {
          return false;
        }
      },
      checkAddUnlimited(){
        var flag = 0;
        for(var i=0; i<this.seatPrice.length; i++) {
          if(this.seatPrice[i].unlimited == true) {
            flag = 1;
          }
        }
        if(flag == 1) {
          return true;
        }
        else {
          return false;
        }
      }
    },

    methods: {
        closeModal() {
            this.$emit('close');
        },
        changeUnlimited(index, event) {
          if(event.target.checked == true) {
            this.seatPrice[index].license_qty = '';
            this.seatPrice[index].max_limit_qty = '';
            this.seatPrice[index].unlimited = true;
            this.additional_seat_price_yearly = 0;
            this.additional_seat_price_monthly = 0;
          }
          else {
            this.seatPrice[index].unlimited = false;
          }
        },
        changeEditUnlimited(index, event) {
          if(event.target.checked == true) {
            this.editseatPrice[index].license_qty = '';
            this.editseatPrice[index].max_limit_qty = '';
            this.editseatPrice[index].unlimited = true;
            this.edit_additional_seat_price_yearly = 0;
            this.edit_additional_seat_price_monthly = 0;
          }
          else {
            this.editseatPrice[index].unlimited = false;
          }
        },
        isActive: function (tabvalue) {
            return this.selectedComponent === tabvalue
        },
        createPackageAction() {
            this.$validator.validateAll().then((result) => {
                if (this.verrors.items.length === 0) {
                    axios('/subscriptionlists',
                    {
                        method: 'POST',
                        data: {
                                unit_type: this.unit_type,      
                                license_name: this.license_name,
                                affiliate: this.affiliate_selected,
                                validity_duration: this.package_validity_duration,
                                is_active: this.package_is_active,
                                probation_window: this.probation_window,
                                reassign_window: this.reassign_window,
                                no_of_reassign: this.no_of_reassign,
                                price_tier: this.priceTier,
                                account_type: this.account_type,
                                price_onetime: this.price_onetime,
                                bundle_price: this.bundle_price,
                                price_after_bundle: this.price_after_bundle,
                                license_qty: this.license_qty,
                                license_type: this.license_type,
                                seatPrice: this.seatPrice,
                                additional_seat_price_yearly: this.additional_seat_price_yearly,
                                additional_seat_price_monthly: this.additional_seat_price_monthly,
                            },
                    }
                    )
                    .then((resp) => {
                        this.unit_type = '';
                        this.price_onetime = '';                 
                        this.price_after_bundle = '';
                        this.license_qty = '';
                        this.bundle_price = '';
                        this.license_type = '';
                        this.package_validity_duration = '';
                        this.package_is_active = '';
                        this.priceTier = [];
                        this.seatPrice = [];
                        this.seatPrice.push({
                          package_name: '',
                          license_qty: '',
                          license_yearly_price: '',
                          license_monthly_price: '',
                          max_limit_qty: '',
                          package_discount: '',
                          unlimited: false,
                        });
                        this.account_type = '';
                        this.additional_seat_price_monthly = '';
                        this.additional_seat_price_yearly = '';
                        this.affiliate_selected = [];
                        this.probation_window = '';
                        this.reassign_window = '';
                        this.no_of_reassign = '';
                        this.license_name = '';
                        this.isModalVisible = false;
                        this.fetchPackageListitems();
                    })
                    .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                        router.push("/forbidden");
                    }
                    });
                }
            })
            .catch(() => {

            });
        },
        toggleDropdown (id) {
            document.getElementById(id).classList.toggle("show");
        },
        showPackageofPaginated() {
            this.fetchPackageListitems();
            this.filterFlag = false;
        },
        filterPackagelistitems() {
            this.filterFlag = true;
            this.fetchPackageListitems();
        },
        fetchPackageListitems() {
            this.loading = true;
            if(this.filterFlag) {
                this.currentPage = 1;
            }
            const params = { _page: this.currentPage }            
            if (this.search_unit_type) {
                params.unit_type = this.search_unit_type;
            }
            if (this.search_name) {
                params.name = this.search_name;
            }
            if (this.search_validity_duration) {
                params.validity_duration = this.search_validity_duration
            }
            if (this.search_is_active) {
                params.is_active = this.search_is_active
            }
            if (this.sortField) {
                params.sortfield = this.sortField
            }
            if (this.publicSortBy) {
                params.sortby = this.publicSortBy
            }
            axios.get('/subscriptionlists', {
                params: params
            })
            .then((resp) => {
                this.loading = false;
                this.package_lists = resp.data.data;
                this.currentPage = resp.data.page;
                this.rows = resp.data.total_rows;
            })
            .catch(error => {

            });
        },
        goToEdit(packagelist) {            
            this.editId = packagelist.id;
            this.isEditModalVisible = true;
            axios.get('/subscription-details/' + this.editId)
                .then((resp) => {
                    this.loading = false;            
                    this.edit_unit_type = resp.data.unitType;
                    this.edit_license_name = resp.data.licenseName;
                    this.edit_validity_duration = resp.data.valitity;
                    this.edit_is_active = resp.data.status == true ? '1' : '0';
                    this.edit_affiliate_selected = resp.data.affliates;
                    this.edit_account_type = resp.data.accountType;
                    this.edit_price_onetime = resp.data.oneTimePrice;
                    this.edit_probation_window = resp.data.probationWindow;
                    this.edit_reassign_window = resp.data.reassignWindow;
                    this.edit_no_of_reassign = resp.data.noOfReassigns;
                    this.editPriceTier =  resp.data.priceTier;   
                    this.edit_license_type = resp.data.licenseType;
                    this.edit_bundle_price = resp.data.bundlePrice;
                    this.edit_price_after_bundle = resp.data.priceAfterBundle;
                    this.edit_license_qty = resp.data.minQty;
                    this.editseatPrice = resp.data.seatPrice;
                    this.editFetchAffiliateOptions();
                    this.edit_additional_seat_price_yearly = resp.data.editAdditionalSeatPriceYearly;
                    this.edit_additional_seat_price_monthly = resp.data.editAdditionalSeatPriceMonthly;

                })
                .catch(error => {

                });
            
        },
        editFetchAffiliateOptions: function() {
          this.affiliate_options = [];
             axios.get('/affiliateoptions/edit-subscription', {
              params: {
                unitType: this.edit_unit_type,
                subscriptionId: this.editId,
              }
             })
             .then((response) => {
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, name: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
                 console.log(this.affiliate_options);
             })
             .catch(error => {

             });

        },

        hideActionMenu(e) {
            var matches = document.getElementsByClassName('dropdown-content');
            for (var i=0; i<matches.length; i++) {
            var container = document.getElementById('dropdown-container'+ i);

            if (!container.contains(e.target)) {
                if (document.getElementById('actionDropdown' + i).classList.contains("show")) {
                    document.getElementById('actionDropdown' + i).classList.remove('show');
                }
            }
            }
        },
        sortMethod: function(field) {
            this.sortField = field;
            if(this.publicSortBy == 'ASC') {
            this.publicSortBy = 'DESC';
            }
            else {
            this.publicSortBy = 'ASC';
            }
            this.fetchPackageListitems();
        },
        updatePackage() { 
            this.$validator.validateAll().then((result) => {
                if (this.verrors.items.length === 0) {
                    axios('/subscriptionlists/'+this.editId,
                    {
                        method: 'PATCH',
                        data: {
                                unit_type: this.edit_unit_type,
                                price_onetime: this.edit_price_onetime,
                                license_name: this.edit_license_name,
                                affiliate: this.edit_affiliate_selected,
                                validity_duration: this.edit_validity_duration,
                                is_active: this.edit_is_active,
                                probation_window: this.edit_probation_window,
                                reassign_window: this.edit_reassign_window,
                                no_of_reassign: this.edit_no_of_reassign,
                                price_tier: this.editPriceTier,
                                account_type: this.edit_account_type,    
                                license_type: this.edit_license_type,
                                bundle_price: this.edit_bundle_price,
                                price_after_bundle: this.edit_price_after_bundle,
                                license_qty: this.edit_license_qty,
                                seatPrice: this.editseatPrice,
                                additional_seat_price_yearly: this.edit_additional_seat_price_yearly,
                                additional_seat_price_monthly: this.edit_additional_seat_price_monthly,
                        },
                    })
                    .then((resp) => {
                        this.isEditModalVisible = false;
                        this.fetchPackageListitems();
                    })
                    .catch(error => { });
                }
            })
            .catch(() => {

            });
        },
        getValidityDuration(value) {
            let elemText = '';
            this.validityDurationOptions.filter(function(elem){
                if(elem.value == value) {
                    elemText = elem.text;
                }
            });
            return elemText;
        },
        getStatus(value) {
            return (value) ? 'Active' : 'Inactive';
        },
        unitTypeChange: function() {
          this.fetchAffiliateOptions();
        },
        fetchAffiliateOptions: function() {
          this.affiliate_options = [];
             axios.get('/affiliateoptions/add-subscription', {
              params: {
                unitType: this.unit_type,
              }
             })
             .then((response) => {
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, name: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
                 console.log(this.affiliate_options);
             })
             .catch(error => {

             });

        },
        addMorePriceTier: function() {
              if(this.priceTier.length > 4) {
                alert("You can't add more than 5 Price Range");
                return false;
              }
              this.priceTier.push({
                license_from: '',
                license_to: '',
                license_price: '',
              });
        },
        addMoreSeat: function() {
              if(this.seatPrice.length > 4) {
                alert("You can't add more than 5 Bundles");
                return false;
              }
              this.seatPrice.push({
                package_name: '',
                license_qty: '',
                license_yearly_price: '',
                license_monthly_price: '',
                max_limit_qty: '',
                package_discount: '',
                unlimited: false,
              });
        },
        addEditMoreSeat: function() {
              if(this.editseatPrice.length > 4) {
                alert("You can't add more than 5 Bundles");
                return false;
              }
              this.editseatPrice.push({
                license_id: '',
                package_name: '',
                license_qty: '',
                license_yearly_price: '',
                license_monthly_price: '',
                max_limit_qty: '',
                package_discount: '',
                unlimited: false,
              });
        },
        addMorePriceTierOfEdit: function() {
              if(this.editPriceTier.length > 4) {
                alert("You can't add more than 5 Price Range");
                return false;
              }
              this.editPriceTier.push({
                license_id: '',
                license_from: '',
                license_to: '',
                license_price: '',
              });
        },
        removePriceTier: function(index) {
          this.priceTier.splice(index, 1);          
        },
        removeSeat: function(index) {
          this.seatPrice.splice(index, 1);          
        },
        formatPrice(e, index) {
          let priceValue = e.target.value;
          this.priceTier[index].license_price = Number(priceValue).toFixed(2);          
        },
        formatEditPrice(e, index) {
          let priceValue = e.target.value;
          this.editPriceTier[index].license_price = Number(priceValue).toFixed(2);          
        },
        formatSeatPrice(e, index, type) {
          let priceValue = e.target.value;
          if(type == 'yearly') {
            this.seatPrice[index].license_yearly_price = Number(priceValue).toFixed(2);          
          }
          else {
            this.seatPrice[index].license_monthly_price = Number(priceValue).toFixed(2);          
          }
          
        },
        formatEditSeatPrice(e, index, type) {
          let priceValue = e.target.value;
          if(type == 'yearly') {
            this.editseatPrice[index].license_yearly_price = Number(priceValue).toFixed(2);          
          }
          else {
            this.editseatPrice[index].license_monthly_price = Number(priceValue).toFixed(2);          
          }
        },
        formatSeatAdditionalPrice(e, mode, type) {
          let priceValue = e.target.value;
          if (mode == 'add') {
            if(type == 'yearly') {
              this.additional_seat_price_yearly = Number(priceValue).toFixed(2);
            }
            else {
              this.additional_seat_price_monthly = Number(priceValue).toFixed(2);
            }
          }
          else {
            if(type == 'yearly') {
              this.edit_additional_seat_price_yearly = Number(priceValue).toFixed(2);
            }
            else {
              this.edit_additional_seat_price_monthly = Number(priceValue).toFixed(2);
            }
          }                    
        },
        formatBundlePrice(e, mode) {
          let priceValue = e.target.value;
          if (mode == 'add') {
            this.bundle_price = Number(priceValue).toFixed(2);
          }
          else {
            this.edit_bundle_price = Number(priceValue).toFixed(2);
          }                    
        },
        formatPriceAfterBundle(e, mode) {
          let priceValue = e.target.value;
          if (mode == 'add') {
            this.price_after_bundle = Number(priceValue).toFixed(2);
          }
          else {
            this.edit_price_after_bundle = Number(priceValue).toFixed(2);
          }                    
        },
        formatOneTimePrice(e, mode) {
          let priceValue = e.target.value;
          if (mode == 'add') {
            this.price_onetime = Number(priceValue).toFixed(2);
          }
          else {
            this.edit_price_onetime = Number(priceValue).toFixed(2);
          }                    
        },
        formatNumber (num) {
          return parseFloat(num).toFixed(2)
        },
        checkPriceRangeNumbers: function(index, arg) {           
            var minRange = 1;
            if((index == 0) && (arg == 'From')) {
              if(parseInt(this.priceTier[index].license_from) != parseInt(minRange)) {
                alert("Range From should be starting with 1");
                this.priceTier[index].license_from = '';
                return false;
              }
            }
            if((index > 0) && (arg == 'From')) {
              var preIndex = parseInt(index-1);
              if(parseInt(this.priceTier[index].license_from) <= parseInt(this.priceTier[preIndex].license_to)) {
                alert("Range From should be higher than the previous Range To");
                this.priceTier[index].license_from = '';
                return false;
              }
            }
            if(arg == 'To') {
                if(parseInt(this.priceTier[index].license_from) > parseInt(this.priceTier[index].license_to)) {
                  alert("Range To should be higher than the Range From");
                  this.priceTier[index].license_to = '';
                  return false;
                }
            
            }           
        },
        editCheckPriceRangeNumbers: function(index, arg) {           
            var minRange = 1;
            if((index == 0) && (arg == 'From')) {             
              if(parseInt(this.editPriceTier[index].license_from) != parseInt(minRange)) {
                alert("Range From should be starting with 1");
                this.editPriceTier[index].license_from = '';
                return false;
              }
            }
            if((index > 0) && (arg == 'From')) {
              var preIndex = parseInt(index-1);
              if(parseInt(this.editPriceTier[index].license_from) <= parseInt(this.editPriceTier[preIndex].license_to)) {
                alert("Range From should be higher than the previous Range To");
                this.editPriceTier[index].license_from = '';
                return false;
              }
            }
            if(arg == 'To') {
                if(parseInt(this.editPriceTier[index].license_from) > parseInt(this.editPriceTier[index].license_to)) {
                  alert("Range To should be higher than the Range From");
                  this.editPriceTier[index].license_to = '';
                  return false;
                }
            
            }           
        },

        checkSeatPriceQty: function(index) {           
            for(var i=0; i<this.seatPrice.length; i++) {
                if(i != index) {
                    if(this.seatPrice[i].license_qty == this.seatPrice[index].license_qty) {
                        alert("Seat Qty " + this.seatPrice[i].license_qty + " is already avaliable");
                        this.seatPrice[index].license_qty = '';
                        return false;
                    }
                }
            }
        },
        checkEditSeatPriceQty: function(index) {           
            for(var i=0; i<this.editseatPrice.length; i++) {
                if(i != index) {
                    if(this.editseatPrice[i].license_qty == this.editseatPrice[index].license_qty) {
                        alert("Seat Qty " + this.editseatPrice[i].license_qty + " is already avaliable");
                        this.editseatPrice[index].license_qty = '';
                        return false;
                    }
                }
            }
        },

    },
    mounted() {
        document.addEventListener('click', this.hideActionMenu);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.hideActionMenu);
    },
    beforeCreate() { 

    },
    created() {
        this.fetchPackageListitems();
        document.body.className = 'naicslist-page';
    },
}
</script>
<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 25px;
  color: #FFF;
  padding: 3px 0px;
  margin-right: 0px;
  margin-left: 0px;
}
*, *::before, *::after {
  outline: none;
}
.input-height-30 {
  line-height: 30px;
}
.naics-code-wrapper {
  padding-left: 15px;
}
hr {
  border-top: 2px solid #8b8b8b;
  margin: 0px;
}
.tasklist-row:nth-of-type(odd) {
  background-color:#fff;
}
.tasklist-row:nth-of-type(even) {
  background-color:#e9e9e9;
}
.search-wrapper {
  background-color: transparent;
}
.heading-seperator {
  border-bottom: 2px solid #00ACEE;
}
.btn-blue {
  background-color: #dc2227 !important;
  border: 1px solid #dc2227 !important;
}
.create-btn {
    line-height: 15px;
    font-weight: bold;
    font-size: 13px;
}
.heading {
  font-size: 15px;
}
.tasklist-item {
  padding: 8px 0px 8px 0px;
}
.package-name {
  padding-left: 20px;
}
.license-criteria-wrapper {
  margin: 20px 0px 10px 0px;
}
.license-criteria-heading {
  font-weight: bold;
  margin-bottom: 5px;
  font-size:12px;
  color: #777777;
}
.price-range-wrapper {
  margin: 10px 0px 5px 0px;
  font-size: 12px;
  color: #777777;
}
.license-criteria-label {
  margin-top: 5px;
  font-size:12px;
  width: 20%;
  display: inline !important; 
  padding-left: 5px;
  color: #777777;
}
.license-range-input {
  width: 21%;
  display: inline !important;  
}
.seat-range-input {
  display: inline !important;  
}
.seat-range-price {
    display: inline !important;  
}
.seat-package-name {
    height: 35px; 
    display: inline !important;  
}
.seat-range-package {
    height: 35px; 
    display: inline !important;  
}
.edit-seat-range-package {
    max-width: 44.33%;
    height: 35px; 
    display: inline !important;  
}
.edit-seat-range-price {
    max-width: 25%;
    height: 35px; 
    display: inline !important;  
}
.license-range-price {
  display: inline !important;  
} 
.delete-icon {
  color: #dc2227;
  font-size: 25px;
} 
</style>
<style>
#purchase-type-wrapper li span.multiselect__option--selected span::before
{
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#purchase-type-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: #fff !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/admin/subscriptionlevel_list.vue